import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/varano-construction/varano-construction/components/ProjectsGallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/varano-construction/varano-construction/node_modules/next/dist/client/app-dir/link.js");
